import {MaskedType} from './masked.interfaces';

export const maskedInputRules = {
  getMaskProps: (maskType: MaskedType) => {
    switch (maskType) {
      case 'money':
        return {
          precision: 2,
          separator: ',',
          delimiter: '.',
          unit: '',
          suffixUnit: '',
        };
      case 'voucher':
        return {
          mask: 'SSSSS SSSSS SSSSS SSSSS SSSSS',
        };
      case 'phone':
        return {
          mask: `${'9'.repeat(4)}-${'9'.repeat(9)}`,
        };
      case 'phone-base':
        return {
          mask: '9'.repeat(7),
        };
      case 'document-number':
        return {
          mask: '9'.repeat(8),
        };
      case 'c2p-key':
        return {
          mask: '9'.repeat(8),
        };
      case 'credit-card-ccv':
        return {
          mask: '9'.repeat(3),
        };
      case 'credit-card-expire':
        return {
          mask: '99/99',
        };
      case 'credit-card-number':
        return {
          mask: '9999 9999 9999 9999',
        };
      case 'people-names':
        return {
          mask: 'N'.repeat(60),
          translation: {
            N: function (val: string) {
              if (val === ' ' || /[a-zA-Z]/.test(val) || val === "'") {
                return val;
              }
              return '';
            },
          },
        };
    }
  },

  getType: (type: MaskedType) => {
    switch (type) {
      case 'c2p-key':
      case 'phone-base':
      case 'phone':
      case 'document-number':
      case 'voucher':
      case 'people-names':
      case 'credit-card-number':
      case 'credit-card-ccv':
      case 'credit-card-expire':
        return 'custom';
      case 'money':
        return type;
      default:
        return '';
    }
  },
};
